import { render, staticRenderFns } from "./ReferralsNewSchedule.vue?vue&type=template&id=13c2a4e4"
import script from "./ReferralsNewSchedule.vue?vue&type=script&lang=js"
export * from "./ReferralsNewSchedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports